var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED1C24;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458,118.2L346.5,8.4C345,6.9,342.9,6,340.7,6H135c-31.1,0-56.3,26.6-56.3,59.4v219.2H51.3v148.6h27.4v13.4   c0,32.7,25.3,59.4,56.3,59.4h269.4c31.1,0,56.3-26.6,56.3-59.4V124.7C460.7,122.3,459.8,119.9,458,118.2z M337.9,24.4l97,95.6   h-52.8c-24.4,0-44.2-19.5-44.2-43.4V24.4z M443.7,446.6c0,22.9-17.6,41.5-39.3,41.5H135c-21.7,0-39.3-18.6-39.3-41.5v-13.4h187   c36.5,0,66-33.3,66-74.3s-29.6-74.3-66-74.3h-187V65.4c0-22.9,17.6-41.5,39.3-41.5h185.9v52.7c0,33.8,27.4,61.3,61.2,61.3h61.6   V446.6z M103.9,396.4v-75h28.7c8.3,0,14.8,2.1,19.4,6.4s7,9.9,7,16.9c0,7-2.3,12.7-7,16.9c-4.7,4.2-11.2,6.4-19.4,6.4h-16.2v28.4   H103.9z M174.2,396.4v-75H199c9.5,0,17.2,3,23.2,8.9c6,5.9,8.9,13.6,8.9,22.9v11.4c0,9.4-3,17-8.9,22.9c-6,5.9-13.7,8.9-23.2,8.9   H174.2z M290.8,354.4v10h-30.2v32H248v-75h48v10h-35.5v22.9H290.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.1,354.2c2.3-2.5,3.5-5.6,3.5-9.4s-1.2-7-3.5-9.5c-2.3-2.5-5.8-3.8-10.5-3.8h-16.2v26.5h16.2   C137.3,357.9,140.7,356.7,143.1,354.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199,331.5h-12.3v55H199c6,0,10.8-2,14.3-6.1c3.5-4.1,5.3-9.3,5.3-15.7v-11.5c0-6.3-1.8-11.5-5.3-15.6   C209.8,333.5,205,331.5,199,331.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.2d3bb48e1966832b6f61ff078c01bff6.svg";
export { ForwardRef as ReactComponent };